import styled from 'styled-components';

import {
  MOBILE_BREAKPOINT,
  TABLET_BREAKPOINT,
  CARD_BREAKPOINT,
} from '../../constants';

export interface StyledNavProps {
  offerGlanceOpen?: boolean;
  showProgressBar?: boolean;
}

export const NavContainer = styled.div<StyledNavProps>`
  width: 100%;
  display: flex;
  flex-direction: column;
  z-index: 2;
  position: relative;
  padding: 0 2rem;
  background-color: #ffffff;
  box-shadow: 0 0.0625rem 0.25rem rgba(0, 0, 0, 0.08);
  transition: z-index 0.5s; // prevents AutoPay tooltip overlap with OfferGlance after a delay
  @media (max-width: ${CARD_BREAKPOINT}) {
    margin: 0;
    box-shadow: 0 0 0.6875rem rgba(0, 0, 0, 0.1);
  }
  @media (max-width: ${MOBILE_BREAKPOINT}) {
    box-shadow: 0 0.0625rem 0.25rem rgba(0, 0, 0, 0.08);
    padding: 0 1rem;
    transition: z-index 0s; // reduce transition for OfferGlance modal
  }
  ${(p: StyledNavProps) =>
    p.offerGlanceOpen &&
    `
    z-index: 5;
  `};
`;

export const MainNavContent = styled.nav<StyledNavProps>`
  height: 5.5625rem;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  @media (max-width: ${TABLET_BREAKPOINT}) {
    height: 4.25rem;
    ${(p: StyledNavProps) =>
      p.showProgressBar &&
      `
      height: 6.375rem;
    `};
  }
`;
MainNavContent.displayName = 'NavContainer';

export const LogoContainer = styled.div<StyledNavProps>`
  position: absolute;
  @media (max-width: ${TABLET_BREAKPOINT}) {
    ${(p: StyledNavProps) =>
      p.showProgressBar &&
      `
      top: 1.4375rem;
      margin: 0 0 2.125rem;
    `};
  }
`;
LogoContainer.displayName = 'LogoContainer';
